(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.getElementById('header');
    const burger = document.getElementById('burger');
    const nav = document.getElementById('nav');

    // Scroll spy: Liquid's link.active only matches whole-page URLs, so anchor
    // links into the homepage's sections never light up. Resolve each nav link
    // to a section on this page and mark the one currently in view. If fewer
    // than two resolve we're not on the homepage — leave link.active alone.
    const spy = [];
    if (nav) {
      nav.querySelectorAll('a.link').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        if (url.pathname !== window.location.pathname) return;
        // The homepage link has no hash; it stands for the hero.
        const id = url.hash ? url.hash.slice(1) : 'home';
        const target = document.getElementById(id);
        if (target) spy.push({ link: link, target: target });
      });
    }

    if (header) {
      const onScroll = () => {
        header.classList.toggle('scrolled', window.scrollY > 40);

        if (spy.length < 2) return;
        let current = 0;
        for (let i = 0; i < spy.length; i++) {
          if (spy[i].target.getBoundingClientRect().top <= 130) current = i;
        }
        spy.forEach((entry, i) => {
          const on = i === current;
          entry.link.classList.toggle('active', on);
          if (on) {
            entry.link.setAttribute('aria-current', 'true');
          } else {
            entry.link.removeAttribute('aria-current');
          }
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (burger && nav) {
      const close = () => {
        nav.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };

      burger.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });

      nav.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const hb = document.getElementById('heroBook');
    if (!hb || !window.matchMedia('(pointer:fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const img = hb.querySelector('.book3d');
    const af = hb.querySelector('.book-af');
    if (!img) return;

    hb.addEventListener('mousemove', (event) => {
      const r = hb.getBoundingClientRect();
      const x = (event.clientX - r.left) / r.width - 0.5;
      const y = (event.clientY - r.top) / r.height - 0.5;
      img.style.transform = `rotateY(${x * 12}deg) rotateX(${-y * 10}deg) translateY(-6px)`;
      if (af) af.style.transform = `rotateY(${x * 8}deg) rotateX(${-y * 6}deg) translateY(-3px)`;
    });

    hb.addEventListener('mouseleave', () => {
      img.style.transform = '';
      if (af) af.style.transform = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('.product-page [data-order-root]');
    if (!root) return;

    const qty = root.querySelector('#qty');
    const priceEl = root.querySelector('#orderPrice');
    const wasEl = root.querySelector('#orderWas');
    const editionEl = root.querySelector('#orderEdition');
    const imgEl = root.querySelector('#orderImg');
    const variantInput = root.querySelector('#orderVariantId');
    const addBtn = root.querySelector('#addCart');

    // See sections/order.liquid — same reasoning: the button contents are
    // rebuilt when the edition switches between available and sold out.
    function setBuyState(available, priceText) {
      if (!addBtn) return;
      addBtn.disabled = !available;
      const label = addBtn.querySelector('span');
      if (!label) return;
      if (available) {
        label.textContent = addBtn.dataset.addLabel + ' — ';
        const t = document.createElement('span');
        t.id = 'total';
        t.textContent = priceText;
        label.appendChild(t);
      } else {
        label.textContent = addBtn.dataset.soldOutLabel;
      }
    }

    function clampQty() {
      const v = Math.max(1, Math.min(20, parseInt(qty.value, 10) || 1));
      qty.value = v;
      return v;
    }

    const minus = root.querySelector('#minus');
    const plus = root.querySelector('#plus');
    if (minus) minus.addEventListener('click', () => { qty.value = (+qty.value) - 1; clampQty(); });
    if (plus) plus.addEventListener('click', () => { qty.value = (+qty.value) + 1; clampQty(); });
    if (qty) qty.addEventListener('change', clampQty);

    root.querySelectorAll('.vopt').forEach((opt) => {
      opt.addEventListener('click', () => {
        root.querySelectorAll('.vopt').forEach((o) => {
          o.classList.remove('active');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('active');
        opt.setAttribute('aria-checked', 'true');

        variantInput.value = opt.dataset.variantId;
        if (editionEl) editionEl.textContent = opt.dataset.title;

        if (priceEl) {
          const small = priceEl.querySelector('small');
          priceEl.textContent = opt.dataset.price;
          if (small) priceEl.appendChild(small);
        }

        if (wasEl) {
          if (opt.dataset.compare) {
            wasEl.textContent = opt.dataset.compare;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        setBuyState(opt.dataset.available === 'true', opt.dataset.price);

        if (imgEl && opt.dataset.image) {
          imgEl.classList.add('swapping');
          const next = new Image();
          next.onload = () => {
            imgEl.src = opt.dataset.image;
            imgEl.removeAttribute('srcset');
            imgEl.classList.remove('swapping');
          };
          next.src = opt.dataset.image;
        }

        // Keep the address bar in step so refresh and sharing land on the
        // edition the visitor is actually looking at.
        const url = new URL(window.location);
        url.searchParams.set('variant', opt.dataset.variantId);
        window.history.replaceState({}, '', url);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-order-root]');
    if (!root) return;

    const qty = root.querySelector('#qty');
    const priceEl = root.querySelector('#orderPrice');
    const wasEl = root.querySelector('#orderWas');
    const titleEl = root.querySelector('#orderTitle');
    const imgEl = root.querySelector('#orderImg');
    const variantInput = root.querySelector('#orderVariantId');
    const addBtn = root.querySelector('#addCart');
    const opts = root.querySelectorAll('.vopt');

    // Unit price in minor units, kept in sync with the selected variant so the
    // button total can be recomputed without another render.
    let unitPrice = null;

    function clampQty() {
      const v = Math.max(1, Math.min(20, parseInt(qty.value, 10) || 1));
      qty.value = v;
      return v;
    }

    // Re-queried rather than cached: the button's contents are rebuilt whenever
    // the selected edition switches between available and sold out.
    function totalEl() {
      return root.querySelector('#total');
    }

    function updateTotal() {
      const v = clampQty();
      const el = totalEl();
      if (unitPrice == null || !el) return;
      el.textContent = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(unitPrice * v)
        : el.textContent;
    }

    // Keeps the button's label honest. Toggling only `disabled` left a faded
    // button still reading "Add to Cart" after switching to a sold-out edition.
    function setBuyState(available, priceText) {
      if (!addBtn) return;
      addBtn.disabled = !available;
      const label = addBtn.querySelector('span');
      if (!label) return;
      if (available) {
        label.textContent = addBtn.dataset.addLabel + ' — ';
        const t = document.createElement('span');
        t.id = 'total';
        t.textContent = priceText;
        label.appendChild(t);
      } else {
        label.textContent = addBtn.dataset.soldOutLabel;
      }
    }

    if (qty) {
      qty.addEventListener('change', updateTotal);
      qty.addEventListener('input', updateTotal);
    }

    const minus = root.querySelector('#minus');
    const plus = root.querySelector('#plus');
    if (minus) minus.addEventListener('click', () => { qty.value = (+qty.value) - 1; updateTotal(); });
    if (plus) plus.addEventListener('click', () => { qty.value = (+qty.value) + 1; updateTotal(); });

    opts.forEach((opt) => {
      opt.addEventListener('click', () => {
        opts.forEach((o) => {
          o.classList.remove('active');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('active');
        opt.setAttribute('aria-checked', 'true');

        variantInput.value = opt.dataset.variantId;
        if (titleEl) titleEl.innerHTML = opt.dataset.title;

        if (priceEl) {
          const small = priceEl.querySelector('small');
          priceEl.textContent = opt.dataset.price;
          if (small) priceEl.appendChild(small);
        }

        if (wasEl) {
          if (opt.dataset.compare) {
            wasEl.textContent = opt.dataset.compare;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        setBuyState(opt.dataset.available === 'true', opt.dataset.price);

        if (imgEl && opt.dataset.image) {
          imgEl.classList.add('swapping');
          const next = new Image();
          next.onload = () => {
            imgEl.src = opt.dataset.image;
            imgEl.removeAttribute('srcset');
            imgEl.classList.remove('swapping');
          };
          next.src = opt.dataset.image;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
